import dayjs from 'dayjs';
import { sessionStorageUtils } from '../utils/storage/storageUtils';
import { StorageKeys } from '../constants/storageKeys';
import { useLitmosTokenTrigger } from '../api/axiosApi';
import useFeature from './useFeature';
import { LITMOS_LOGIN_KEY_LIFETIME } from '../constants/globals';
import { minutesToMs } from '../utils/dateUtils';
import { FeatureToggleCodename } from '../types/enums';

export const useGetLitmosToken = () => {
  const reuseLitmosLoginKey = useFeature(FeatureToggleCodename.reuseLitmosLoginKey);
  const fetchToken = useLitmosTokenTrigger();

  return async () => {
    if (!reuseLitmosLoginKey) {
      return fetchToken();
    }

    const storageData = sessionStorageUtils.get(StorageKeys.LITMOS_SESSION_DATA);

    if (storageData) {
      const isValidStorage =
        dayjs().diff(storageData?.timestamp, 'millisecond') < LITMOS_LOGIN_KEY_LIFETIME - minutesToMs(1);

      if (isValidStorage) {
        return storageData;
      }
    }

    const data = await fetchToken();

    if (data) {
      sessionStorageUtils.save(StorageKeys.LITMOS_SESSION_DATA, {
        loginURL: data.loginURL ?? '',
        token: data.loginKey ?? '',
        timestamp: dayjs().toDate(),
      });
    }

    return data;
  };
};
